import { W, H, R } from "./props";

export const RITUAL_DURATION = 10;
export const ritualCaption = (tt) => (tt > 0.8 && tt < 8.6 ? "Somewhere in the Colorado Rockies..." : null);

const GROUND = 150;

function cloak(ctx, x, t, i, big) {
  const s = big ? 1.5 : 1, sway = Math.round(Math.sin(t / 700 + i * 1.3) * 1), y = big ? H - 4 : GROUND + 2;
  const w = 12 * s, h = 34 * s, px = x + sway;
  R(ctx, "#5c0f0f", px, y - h, w, h);
  R(ctx, "#7f1d1d", px + 2 * s, y - h, w - 4 * s, h);
  R(ctx, "#5c0f0f", px + 2 * s, y - h - 6 * s, w - 4 * s, 8 * s);
  R(ctx, "#7f1d1d", px + 3 * s, y - h - 8 * s, w - 6 * s, 4 * s);
  R(ctx, "#050203", px + 4 * s, y - h - 3 * s, w - 8 * s, 5 * s);
  R(ctx, "#3a0808", px - 1 * s, y - 3 * s, w + 2 * s, 3 * s);
  if (i % 2 === 0) { const up = Math.sin(t / 500 + i) > 0 ? 6 : 4; R(ctx, "#7f1d1d", px - 2 * s, y - h - up * s, 3 * s, 14 * s); R(ctx, "#7f1d1d", px + w - 1 * s, y - h - up * s, 3 * s, 14 * s); }
  R(ctx, "rgba(245,158,11,0.18)", px + (x < 160 ? w - 3 * s : 0), y - h, 3 * s, h);
}

function fire(ctx, cx, base, t, scale) {
  for (let i = 0; i < 9; i++) {
    const h = (10 + Math.abs(Math.sin(t / 110 + i * 1.9)) * 26) * scale, w = 4 * scale;
    const x = cx - 18 * scale + i * 4 * scale;
    R(ctx, "#b91c1c", x, base - h, w, h); R(ctx, "#f97316", x + 1, base - h * 0.75, w - 1, h * 0.75); R(ctx, "#fde047", x + 1, base - h * 0.4, w - 2, h * 0.4);
  }
}

function distantFires(ctx, t) {
  [[24, 104], [70, 98], [238, 100], [282, 106], [300, 96]].forEach(([x, y], i) => {
    const f = 1 + Math.sin(t / 150 + i * 2) * 0.5;
    const g = ctx.createRadialGradient(x, y, 0, x, y, 14);
    g.addColorStop(0, "rgba(249,115,22,0.5)"); g.addColorStop(1, "rgba(249,115,22,0)");
    ctx.fillStyle = g; ctx.fillRect(x - 14, y - 14, 28, 28);
    R(ctx, "#f97316", x - 1, y - 2 - f, 3, 3 + f); R(ctx, "#fde047", x, y - 1, 1, 2);
  });
}

export function drawRitual(ctx, tt, now) {
  const pan = -14 + Math.min(1, tt / RITUAL_DURATION) * 14;
  ctx.save(); ctx.translate(Math.round(pan), 0);
  R(ctx, "#06030a", -20, 0, W + 40, H);
  const sky = ctx.createLinearGradient(0, 40, 0, GROUND);
  sky.addColorStop(0, "rgba(60,8,8,0)"); sky.addColorStop(1, "rgba(90,20,10,0.55)");
  ctx.fillStyle = sky; ctx.fillRect(-20, 40, W + 40, GROUND - 40);
  for (let i = 0; i < 7; i++) { const x = i * 56 - 30; for (let k = 0; k < 28; k++) R(ctx, "#0d0610", x + k * 2, 78 + Math.abs(k - 14) * 2, 2, GROUND); }
  distantFires(ctx, now);
  for (let i = 0; i < 16; i++) { const x = i * 22 - 14; R(ctx, "#05030a", x + 6, 112, 3, GROUND - 112); for (let k = 0; k < 3; k++) R(ctx, "#070410", x + 7 - (2 + k * 3), 100 + k * 7, 4 + k * 6, 7); }
  R(ctx, "#4a3a44", -20, GROUND, W + 40, H - GROUND); R(ctx, "#6b4a48", -20, GROUND, W + 40, 2);
  const glow = ctx.createRadialGradient(160, 120, 6, 160, 120, 130);
  glow.addColorStop(0, "rgba(249,115,22,0.45)"); glow.addColorStop(1, "rgba(249,115,22,0)");
  ctx.fillStyle = glow; ctx.fillRect(20, 0, 280, H);
  R(ctx, "#2a160a", 159, 72, 3, GROUND - 72); R(ctx, "#2a160a", 150, 92, 21, 2);
  R(ctx, "#1a1418", 153, 90, 15, 34); R(ctx, "#1a1418", 155, 82, 11, 9); R(ctx, "#050203", 157, 85, 7, 5);
  R(ctx, "#1a1418", 149, 92, 4, 12); R(ctx, "#1a1418", 168, 92, 4, 12);
  for (let i = 0; i < 6; i++) R(ctx, "#3a2414", 138 + i * 7, GROUND - 6 - (i % 2) * 3, 12, 4);
  fire(ctx, 160, GROUND - 2, now, 1.1);
  for (let i = 0; i < 26; i++) {
    const ey = (now * 0.03 + i * 37) % 110, ex = 160 + Math.sin(now / 400 + i) * (8 + ey * 0.25);
    R(ctx, i % 3 ? "#f97316" : "#fde047", ex, GROUND - 20 - ey, 1, 1);
  }
  for (let i = 0; i < 5; i++) { const sy = (now * 0.012 + i * 22) % 80; R(ctx, `rgba(60,50,55,${0.35 - sy / 260})`, 152 + Math.sin(now / 900 + i) * 6 - sy * 0.2, 60 - sy, 16, 10); }
  [62, 88, 114, 196, 222, 248].forEach((x, i) => cloak(ctx, x, now, i, false));
  [18, 276].forEach((x, i) => cloak(ctx, x, now, i + 6, true));
  ctx.restore();
  for (let i = 0; i < 70; i++) R(ctx, "#cbd5e1", (i * 73.13 - now * 0.01) % W < 0 ? 0 : (i * 73.13 + now * 0.012) % W, (i * 41.7 + now * 0.025) % H, 1, 1);
  const v = ctx.createRadialGradient(W / 2, H / 2, 70, W / 2, H / 2, 200);
  v.addColorStop(0, "rgba(0,0,0,0)"); v.addColorStop(1, "rgba(0,0,0,0.8)"); ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 1 ? 1 - tt : tt > RITUAL_DURATION - 0.9 ? (tt - (RITUAL_DURATION - 0.9)) / 0.9 : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}
